import React, { useState } from 'react';
import { ChevronsUpDown, Trash2 } from "lucide-react";
import Badge from '../UI/Badge';
import { account_name, can_visit } from '../../helpers';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function DocflowCategoryDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    setEditDocflowModalOpen = () => {},
    setDocflowEditData = () => {},
    setActiveDeleteModal = () => {},
    setDocflowDeletedId = null,
    setPreviousScrollPosition = () => {},
  } = props;

  const [orderBy, setOrderBy] = useState();

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const LimitText = ({ text, limit }) => {
    if (text.length <= limit) {
      return text;
    } else {
      const limitText = text.substring(0, limit) + "...";
      return limitText;
    }
  };

  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th>Select Practice</th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("name");
                  }}
                  className={
                    orderBy === "name" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>Name <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th>
                <div
                  onClick={() => {
                    handleOrderChange("status");
                  }}
                  className={
                    orderBy === "status" ? "docpro_accent_color" : ""
                  }
                >
                  <div style={styles}>Status <ChevronsUpDown size={"12"} />
                  </div>
                </div>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData && tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index}>
                    <td 
                      className='py-2 pointer' style={{ maxWidth: "250px" }}
                      onClick={() => {
                        setEditDocflowModalOpen(true);
                        setDocflowEditData(item);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.everyone ? (
                        <span className='docpro_fs_12'>
                          <Badge color="purple">Everyone</Badge>
                        </span>
                      ) : (
                        item?.practice_ids?.map((item, index) => (
                        <span key={index} className='docpro_fs_12 mr-1' style={{ display: "inline-flex", marginBottom: '2px' }}>
                          <Badge color="blue">{account_name(item)}</Badge>
                        </span>
                      ))
                    )}
                    </td>
                    <td 
                      className='py-2 pointer'
                      onClick={() => {
                        setEditDocflowModalOpen(true);
                        setDocflowEditData(item);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      <LimitText text={item?.name || ""} limit={30} />
                    </td>
                    <td 
                      className='py-2 pointer'
                      onClick={() => {
                        setEditDocflowModalOpen(true);
                        setDocflowEditData(item);
                        setPreviousScrollPosition(window.scrollY);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {item?.status === "Active" ? (
                        <Badge color="green">Active</Badge>
                      ) : (
                        <Badge color="red">Deactive</Badge>
                      )}
                    </td>
                    <td>
                      <div className="docpro_icon_btns">
                        {(can_visit("administrator") && can_visit("administrator_docflow_template")) && (
                          <button 
                            type="button" className="docpro_icon_btn"
                            onClick={() => {
                              setDocflowDeletedId(item?.id);
                              setActiveDeleteModal(true);
                              setPreviousScrollPosition(window.scrollY);
                              window.scrollTo(0, 0);
                            }}
                          >
                            <Trash2 width={20} height={20} />
                            <span className="docpro_tip">Delete</span>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="10">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="10">
                  Loading...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
